import type { ResourceEndpoints } from '../core'

export const sseTasksEndpoints = {
  collection: '/api/v1/sse-tasks',
  item: (id: string) => `/api/v1/sse-tasks/${encodeURIComponent(id)}`,
  /** A server-sent event stream: the task's state, pushed every time it changes. */
  events: (id: string) => `/api/v1/sse-tasks/${encodeURIComponent(id)}/events`,
} satisfies ResourceEndpoints & { events: (id: string) => string }
